var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 border-b-2 border-gray-300"},[_c('div',[_c('BaseInput',{attrs:{"type":"text","field_name":"","placeholder":_vm.$t('search_filter')},on:{"input":_vm.updateQuery},model:{value:(_vm.internalQuery),callback:function ($$v) {_vm.internalQuery=$$v},expression:"internalQuery"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }